import { render, staticRenderFns } from "./RequisiteModal.vue?vue&type=template&id=4076c559&"
import script from "./RequisiteModal.vue?vue&type=script&lang=js&"
export * from "./RequisiteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports